<script lang="ts" setup>

  const { t } = useI18n()
</script>

<template>
  <div class="c-app-links">
    <a
      href="https://itunes.apple.com/fr/app/bookandgolf/id434634223"
      target="_blank"
    >
      <Button type="secondary">
        <div class="app-button">
          <SvgIcon
            :height="27"
            :width="27"
            icon="logo-apple"
          />
          <div class="text">
            <div class="up">{{ t("footer.app-store-button-up") }}</div>
            <div class="down">{{ t("footer.app-store-button-down") }}</div>
          </div>
        </div>
      </Button>
    </a>
    <a
      href="https://play.google.com/store/apps/details?id=com.bookandgolf"
      target="_blank"
    >
      <Button type="secondary">
        <div class="app-button">
          <SvgIcon
            :height="27"
            :width="27"
            icon="logo-google-play"
          />
          <div class="text">
            <div class="up">{{ t("footer.google-play-button-up") }}</div>
            <div class="down">
              {{ t("footer.google-play-button-down") }}
            </div>
          </div>
        </div>
      </Button>
    </a>
  </div>
</template>

<style scoped>

.c-app-links {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: auto;
  overflow-x: visible;

  .c-button {
    width: 9.75rem;
    height: 3.25rem;
    flex: unset;
    padding: 0.35rem 0.325rem;
    text-align: left;

    &:not(:last-child) {
      margin-right: 0.5em;
    }

    .app-button {
      display: flex;
      flex-direction: row;

      .c-icon {
        width: 2rem;
        height: 2.25rem;
      }

      .text {
        margin-left: 0.5rem;
        white-space: nowrap;

        .up {
          color: white;
          font-family: Open-Sans, sans-serif;
          font-size: 0.75rem;
          font-weight: 600;
          line-height: 1.36;
        }

        .down {
          color: white;
          font-family: Open-Sans, sans-serif;
          font-size: 1.125rem;
          font-weight: 600;
          line-height: 1.33;
          text-wrap: none;
        }
      }
    }
  }
}
</style>
